'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckDate = function () {
  function CheckDate() {
    _classCallCheck(this, CheckDate);
  }

  _createClass(CheckDate, null, [{
    key: 'jump',
    value: function jump(steps, id, stepId, stepperIconActiveId, first) {
      //stepperIconActiveId: Id des aktiven Steps
      //Hier Korrektur der Id, zu der gesprungen werden soll
      //VAS-22828: Änderung war hier notwendig, geht evtl. auch ohne -> Setzen der Id `s über index/startindex wurde entfernt
      //Bsp.: Produkt mit Nachweis, Klick auf Zahlweise, Klick auf Weiter -> id war hier 5 u. nicht 6
      //Produkt mit Nachweis, Klick auf Zahlweise, Klick auf Zurück -> id war hier 3 u. nicht 4
      if (stepperIconActiveId != undefined && stepperIconActiveId != '' && stepperIconActiveId != null && stepId != undefined && stepId != null && stepId != '') {
        if (stepId < stepperIconActiveId) {
          id++;
          stepId++;

          if (stepId < stepperIconActiveId) {
            if (stepId === stepperIconActiveId - 1) {
              id++;
            } else {
              id++;
              stepId++;
              if (stepId < stepperIconActiveId) {
                id++;
              }
            }
          }
        } else if (stepId > stepperIconActiveId) {
          id--;
          stepId--;
          if (stepId > stepperIconActiveId) {
            id--;
            stepId--;
          }
        }
      }

      if (id !== null && id !== undefined && steps !== null && steps !== undefined) {
        (0, _jquery2.default)(".c").hide();
        (0, _jquery2.default)("#" + id).show();
        for (var i = 1; i <= steps; i++) {
          (0, _jquery2.default)("#i" + i).removeClass().addClass("StepperIcon");
        }
        (0, _jquery2.default)("#i" + id).removeClass().addClass("StepperIconActive");
      }

      if (first !== null && first !== undefined) {
        if (first !== undefined && first !== null) {
          if (first.Key !== undefined && first.Key !== null) {
            if (first.Key.props !== undefined && first.Key.props !== null) {
              if (first.Key.props.Id !== undefined && first.Key.props.Id !== null) {
                document.getElementById(first.Key.props.Id).focus();
              }
            };
          }
        }
      }

      if (document.getElementsByClassName('StepperIconActive')) {
        if (document.getElementsByClassName('StepperIconActive').length > 0) {
          stepperIconActiveId = document.getElementsByClassName('StepperIconActive')[0].innerHTML;

          return stepperIconActiveId;
        }
      }
    }
  }]);

  return CheckDate;
}();

exports.default = CheckDate;